import React, { useEffect, useState } from 'react'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import FormFieldset from 'components/UI/AsideModal/Form/FormFieldset'
import asideModalStore from 'Stores/asideModalStore'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'

import st from './ChangeTranslation.module.scss'
import { observer } from 'mobx-react'
import useLocalization from 'hooks/useLocalization'
import { ReactComponent as RuIcon } from 'components/HeadBox/img/ru.svg'
import { ReactComponent as EnIcon } from 'components/HeadBox/img/en.svg'
import { ReactComponent as KzIcon } from 'components/HeadBox/img/kz.svg'
import { superAxiosRequest } from 'axiosApi'

const LanguageIcons = {
  1: <EnIcon />,
  2: <RuIcon />,
  3: <KzIcon />,
}
const ChangeTranslation = ({
  partitions,
  subPartitions,
  languages,
  selectedItem,
}) => {
  const [subPartitionsForRender, setSubPartitionsForRender] =
    useState(subPartitions)
  const [isChangeDisabled, setIsChangeDisabled] = useState(false)

  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
    loading,
  } = asideModalStore

  useEffect(() => {
    if (selectedItem) {
      setSubPartitionsForRender(
        subPartitions?.filter(
          (item) => item?.parent_partition === selectedItem?.partition?.id,
        ),
      )
      selectedItem?.partition &&
        changeValues(selectedItem?.partition, 'partition')
      selectedItem?.subPartition &&
        changeValues(selectedItem?.subPartition, 'subPartition')
    }
  }, [selectedItem])

  const handlePartitionChange = (o) => {
    changeValues(null, 'subPartition')
    setSubPartitionsForRender(
      subPartitions?.filter((item) => item?.parent_partition == o?.id),
    )
    changeValues(o, 'partition')
  }

  const handleLaguageChange = (o) => {
    changeValues(o, 'language')
    if (modalValue?.subPartition && modalValue?.partition && !loading) {
      superAxiosRequest({
        method: 'get',
        link: 'localization/translations',
        params: {
          section: modalValue?.partition?.short_name,
          subsection: modalValue?.subPartition?.short_name,
          lc: o?.short_name,
        },
      }).then((res) => {
        if (!res?.data?.result?.[0]) {
          setIsChangeDisabled(true)
          changeValues(null, 'translation')
          return
        } else {
          changeValues(
            JSON.stringify(res?.data?.result?.[0]?.text),
            'translation',
          )
          changeValues(res?.data?.result?.[0]?.id, 'id')
          setIsChangeDisabled(false)
        }
      })
    }
  }

  const { translate } = useLocalization({
    section: 'user',
    subsection: 'translator',
    dict: {
      edit: 'Edit',
      copy: 'Copy',
      delete: 'Delete',
      save: 'Save',
      search: 'Search',
      search_input: 'Search by student name, surname, or patronymic...',
      date: 'Date',
      reset_all: 'Reset All',
      apply: 'Apply',
      filter: 'Filter',
      changeTranslation: 'Change translation',
      createTranslation: 'Create translation',
      text: 'Text',
      language: 'Language',
      partition: 'Partition',
      subpartition: 'Subpartition',
      page: 'page',
      englishText: 'English Text',
      english: 'English',
      kazakhAndRussian: 'Kazakh / Russian text',
      russian: 'Russian',
      kazakh: 'Kazakh',
      creatingTranslation: 'Creating a new translation',
      createPartition: 'Create Partition',
      of: 'of',
      name: 'Name',
      shortName: 'Short name',
      parentPartition: 'Parent Partition',
    },
  })

  return (
    <FormFieldset>
      <div className={st.field}>
        <FormField>
          <FormLabel isRequired>{translate?.partition}: </FormLabel>
          <FormInput isError={check('partitions')}>
            <SelectCustom
              isDisabled={Boolean(selectedItem)}
              placeholder={translate?.partition}
              options={partitions}
              sortKey='partition'
              valueID={modalValue?.partition?.id}
              onChange={handlePartitionChange}
              error={check('partition')}
            />
          </FormInput>
        </FormField>
        <FormField>
          <FormLabel isRequired>{translate?.subpartition}: </FormLabel>
          <FormInput isError={check('subPartition')}>
            <SelectCustom
              isDisabled={Boolean(selectedItem) || !modalValue?.partition}
              placeholder={translate?.subpartition}
              options={subPartitionsForRender}
              sortKey='subPartition'
              valueID={modalValue?.subPartition?.id}
              onChange={(o) => changeValues(o, 'subPartition')}
              error={check('subPartition')}
            />
          </FormInput>
        </FormField>
        <FormField>
          <FormLabel isRequired>{translate?.language}: </FormLabel>
          <FormInput isError={check('language')}>
            <SelectCustom
              isDisabled={!modalValue?.subPartition}
              placeholder={translate?.language}
              options={languages.map((language) => ({
                ...language,
                label: (
                  <div className={st.optionLabel}>
                    {LanguageIcons?.[language?.id]}
                    <div className={st.languageText}>{language?.full_name}</div>
                  </div>
                ),
              }))}
              optionLabelKey={'full_name'}
              sortKey='language'
              valueID={modalValue?.language?.id}
              onChange={handleLaguageChange}
              error={check('language')}
            />
          </FormInput>
        </FormField>
      </div>
      <FormField>
        <FormInput isError={check('translation')}>
          <textarea
            disabled={!modalValue?.language || isChangeDisabled}
            placeholder={translate?.text}
            type='text'
            value={modalValue?.translation || ''}
            onChange={(e) => changeValues(e.target.value, 'translation')}
          />
        </FormInput>
      </FormField>

      {isChangeDisabled && (
        <span>No translation found, please create one in create modal</span>
      )}
    </FormFieldset>
  )
}

export default observer(ChangeTranslation)
